import Empty from "./Fallback/Empty";
import Fallback from "./Fallback/Index";
import Dashboard from "./Fallback/Dashboard";
import ComingSoon from "./Fallback/ComingSoon";

export default Object.assign(Fallback, { Empty, Dashboard, ComingSoon });
